import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';

class CandidateTag extends DomainObject {
  id;
  name;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable
    });

    this.merge(other);
  }
}

export default CandidateTag;
